export default __webpack_public_path__ + "d076bf5.png";